import styled from 'styled-components';

// Adds element only visible to screen readers
export const SrOnly = styled.span`
  &:not(:focus) {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    border: 0;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(0 0 99.9% 99.9%);
    overflow: hidden;
    white-space: nowrap;
  }
`;
